module.exports = "/_next/static/images/Reliability@2x-8a94a6499bba775868e75b890896d1b3.png";